import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import {
    DeletarMotivoNaoProcedenciaController,
    ListagemDosMotivoNaoProcedenciaController,
} from "../../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
// import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../../Utils/OrSpinner";
import Table from "../../../../../Table";
import { IListarMotivoParalisarNaoProcedencia } from "../../../../../../Interfaces/AssistenciaTecnica/Atendimento/MotivoNaoProcedencia/MotivoNaoProcedencia";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";

interface IListagemMotivoNaoProcedencia {
    lstMotivoParalisacao: Array<any>;
    setEdit: (tpa: any) => void;
    updateListMotivoParalisacao: () => void;
}

export default function ListagemMotivoNaoProcedencia(
    props: IListagemMotivoNaoProcedencia
) {
    const {
        value: listarMotivosParalisacao,
        loading: lstMotivosParalisacaoLoading,
    } = useAsyncEffect(() => ListagemDosMotivoNaoProcedenciaController(), []);

    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_MOTIVO_NAO_PROCEDENCIA",
            text: "Motivo Não Procedência",
            formatter: rowMotivoNaoProcedencia,
            sort: true,
        },
        {
            dataField: "button",
            text: "Editar",
            formatExtraData: props.setEdit,
            formatter: (c, row, _, setEdit) => (
                <div className="d-flex justify-content-center align-items-center p-3 g-2">
                    <button
                        className="btn btn-icon btn-outline-primary"
                        onClick={() => {
                            setEdit(row);
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                </div>
            ),
        },
        {
            dataField: "button",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex justify-content-center align-items-center">
                    <div>
                        {
                            <button
                                className="btn btn-sm btn-outline-danger font-weight-bold"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este Motivo de Não Procedência?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarMotivoNaoProcedenciaController(
                                                row.ID_MOTIVO_NAO_PROCEDENCIA
                                            ).then(() => {
                                                props.updateListMotivoParalisacao();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                            </button>
                        }
                    </div>
                </div>
            ),
        },
    ];

    function rowMotivoNaoProcedencia(
        cell: string,
        row: IListarMotivoParalisarNaoProcedencia
    ) {
        return (
            <div className="rowCapysTCA d-flex justify-content-between align-items-center mr-5">
                <div>
                    <label className="mb-1">
                        {row.DS_MOTIVO_NAO_PROCEDENCIA}
                    </label>

                    <div>
                        {row.DS_MOTIVO_NAO_PROCEDENCIA && (
                            <>
                                <span
                                    className={`label abel-pill label-inline label-primary`}
                                >
                                    {row.ID_MOTIVO_NAO_PROCEDENCIA} {"-"}{" "}
                                    {row.DS_MOTIVO_NAO_PROCEDENCIA}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="d-flex flex-columns row">
                <div className="col-12 mt-5">
                    <OrSpinner
                        loading={lstMotivosParalisacaoLoading}
                        spinner="capys"
                    >
                        <Table
                            keyField="ID_MOTIVO_PARALIZACAO_SLA"
                            columns={columns}
                            data={listarMotivosParalisacao ?? []}
                            sizePerPage={10}
                            loading={lstMotivosParalisacaoLoading}
                            noDataIndication={
                                <div className="text-center text-muted">
                                    Nenhum Motivo de Não Procedência
                                </div>
                            }
                            wrapperClasses="wrapperTable mw-100 x-scroll"
                            classes="tableClasses"
                            bordered={false}
                            center
                            defaultStyle={{
                                align: "center",
                                classes: "p-2",
                            }}
                        />
                    </OrSpinner>
                </div>
            </div>
        </>
    );
}
